import { render, staticRenderFns } from "./costHelp.vue?vue&type=template&id=865e543c&"
import script from "./costHelp.vue?vue&type=script&lang=js&"
export * from "./costHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865e543c')) {
      api.createRecord('865e543c', component.options)
    } else {
      api.reload('865e543c', component.options)
    }
    module.hot.accept("./costHelp.vue?vue&type=template&id=865e543c&", function () {
      api.rerender('865e543c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wVQyTUPRsAZ9/JS/costHelp.vue"
export default component.exports